import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'src/components/Button';
import ButtonDuo from 'src/components/ButtonDuo';
import { PRODUCT_REGION } from 'src/constants/product';
import { useModal } from 'src/ModalContext';
import { postImpActivate, postImpUnsubscribe, postPaypalUnsubscribe } from 'src/services/checkout';
import { getDurationTranslation, getRestartConfirmTranslation, getRestartSuccessTranslation } from 'src/services/util';
import { useUser } from 'src/UserContext';
import { isKorean } from 'src/services/util';

/**
 * SUB_DEACTIVATED
 */
export default function AutoPaymentDeactivatedCard({ obj }: { obj: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const { userInfo } = useUser();
  const getName = () => {
    return isKorean() ? obj.koName : obj.enName;
  };

  const onCancel = useCallback(() => {
    showModal({
      component: <Trans i18nKey="product/auto-payment/confirm_cancel_2" values={{ name: getName() }}></Trans>,
      success: async () => {
        try {
          if (userInfo.country === PRODUCT_REGION.KR) {
            await postImpUnsubscribe(obj.customerId);
          } else {
            await postPaypalUnsubscribe(obj.customerId);
          }
          showModal({
            message: t('product/auto-payment/success_cancel_2'),
            success: () => {
              location.reload();
            },
          });
        } catch (e) {
          console.error(e);
          showModal({
            message: e.message,
            success: () => {
              // success
            },
          });
        }
      },
      fail: () => {
        // no action
      },
    });
  }, [obj, userInfo]);

  const onActivate = useCallback(() => {
    showModal({
      // {상품명}의 자동결제를 재개하시겠습니까? 현재 시점을 기준으로 {결제주기}일마다 자동결제 됩니다.
      component: (
        <Trans i18nKey={getRestartConfirmTranslation(obj.durationType)} values={{ name: getName(), period: obj.duration }}></Trans>
      ),
      success: async () => {
        // TODO 결제 API
        try {
          await postImpActivate({
            userProductId: obj.id,
          });

          // 성공시
          showModal({
            // 재결제가 완료되었습니다. 현재 시점을 기준으로 {결제주기}일 마다 자동 결제됩니다
            component: <Trans i18nKey={getRestartSuccessTranslation(obj.durationType)} values={{ period: obj.duration }}></Trans>,
            success: () => {
              location.reload();
              // no action
            },
          });
        } catch (e) {
          showModal({
            // `결제에 실패하였습니다. {PG 리턴메시지}`
            message: t('product/auto-payment/fail_restart') + e.message,
            success: () => {
              // no action
            },
          });
        }
      },
      fail: () => {
        // no action
      },
    });
  }, [obj, userInfo]);

  return (
    <div className="mt-3">
      <div className="border border-ice-blue bg-white rounded px-6 pt-6 pb-5 min-h-48">
        <div className="N_16_R text-black">{getName()}</div>
        <div className="N_12_R text-brown-grey mt-1">
          <Trans i18nKey={getDurationTranslation(obj.durationType)} values={{ period: obj.duration }}></Trans>
        </div>
        {/* <div className="mt-4 flex">
          <Icon name="delete" size="16" />
          <div className="N_12_R text-purpley-pink ml-1">{t('product/auto-payment/sub_deactivated')}</div>
        </div> */}
        <div className="mt-6">
          {userInfo.country === PRODUCT_REGION.KR ? (
            <ButtonDuo
              title1={t('product/auto-payment/cancel_1')} /* 해지 */
              title2={t('product/auto-payment/restart')} /* 결제재개 */
              onClick1={onCancel}
              onClick2={onActivate}
            />
          ) : (
            <Button title={t('product/auto-payment/cancel_1')} onClick={onCancel} />
          )}
        </div>
      </div>
    </div>
  );
}
